import { render, staticRenderFns } from "./EModalCarteiraInfantil.vue?vue&type=template&id=9d6f0b58"
import script from "./EModalCarteiraInfantil.vue?vue&type=script&lang=js"
export * from "./EModalCarteiraInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports